"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const cw_http_service_1 = require("@dialogexe/cw-http-service");
const actions_1 = require("./actions");
const cw_parameters_provider_1 = require("@dialogexe/cw-parameters-provider");
const movieInfoConverter_1 = require("../converters/movieInfoConverter");
const getWatchList = () => {
    const request = new cw_http_service_1.Request(cw_parameters_provider_1.parametersProvider.get('api.filmGrail'));
    const profile = JSON.parse(localStorage.getItem("cw-profile"));
    const token = profile ? profile.token : '';
    return request
        .get('watchlist', null, {
        headers: {
            'X-Token': token
        }
    });
};
function* fetchWatchList() {
    try {
        yield effects_1.put(actions_1.actionCreators.requestWatchList());
        const myWatchList = yield effects_1.call(getWatchList);
        const data = movieInfoConverter_1.convertMultiToMovieInfoModel(myWatchList.data);
        yield effects_1.put(actions_1.actionCreators.putWatchList(data));
    }
    catch (error) {
        yield effects_1.put(actions_1.actionCreators.fetchWatchListFailed(error.response));
    }
}
const addMovie = ({ movieId }) => {
    const request = new cw_http_service_1.Request(cw_parameters_provider_1.parametersProvider.get('api.filmGrail'));
    const profile = JSON.parse(localStorage.getItem("cw-profile"));
    const token = profile ? profile.token : '';
    return request
        .post('addMovieToWatchList', { id: movieId }, null, {
        headers: {
            'X-Token': token
        }
    });
};
function* addToWatchList(action) {
    try {
        const isMovieAdded = yield effects_1.call(addMovie, { movieId: action.movie.movieId });
        if (isMovieAdded) {
            yield effects_1.put(actions_1.actionCreators.putMovieToWatchList(action.movie));
        }
    }
    catch (error) {
        console.log(error);
    }
}
exports.watchFetchWatchListAsync = effects_1.takeLatest(actions_1.actions.FETCH_WATCH_LIST_SUCCESS, fetchWatchList);
exports.addMovieToWatchLIstAsync = effects_1.takeLatest(actions_1.actions.ADD_TO_WATCH_LIST, addToWatchList);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/watchList/sagas.ts